import React, { useEffect, useState } from 'react'
import {
    ModalPayload,
    modalService,
    ModalSize,
} from '../../services/ModalService'
import ModalPortal from './ModalPortal'
import cx from 'classnames'
import styles from './ModalPortal.module.scss'

export const ModalRoot = () => {
    const [modals, setModals] = useState<ModalPayload[]>([])

    useEffect(() => {
        const unsubscribe = modalService.subscribe(setModals)
        return () => {
            unsubscribe()
        }
    }, [])

    useEffect(() => {
        if (modals.length)
            document.querySelector('html')?.classList.add('zr-overflow-hidden')
        else
            document
                .querySelector('html')
                ?.classList.remove('zr-overflow-hidden')
    }, [modals])

    if (modals.length === 0) return null

    const getModalClass = (size: ModalSize) => {
        switch (size) {
            case 'lg':
                return styles['zr-modal-content-lg']
            case 'md':
                return styles['zr-modal-content-md']
            case 'sm':
                return styles['zr-modal-content-sm']
            case 'full':
                return styles['zr-modal-content-full']
            default:
                return styles['zr-modal-content']
        }
    }

    return (
        <ModalPortal>
            {modals.map((modal) => (
                <div className={cx(styles['zr-modal-overlay'])} key={modal.id}>
                    <div className={cx(getModalClass(modal.size))}>
                        <button
                            className={cx(styles['zr-close-button'])}
                            onClick={() => {
                                modalService.hide(modal.id)
                                modal.onClose?.()
                            }}
                        >
                            &times;
                        </button>
                        {modal.heading && (
                            <div className={cx(styles['zr-modal-header'])}>
                                {modal.heading}
                            </div>
                        )}
                        <div className={cx(styles['zr-modal-body'])}>
                            {modal.content}
                        </div>
                    </div>
                </div>
            ))}
        </ModalPortal>
    )
}
